/**
 * Ключ звучания самой реплики. Ключ ведётся по строке, а не по диалогу: в перечне соседние
 * строки бывают репликами одного разговора, и остановка должна идти по той строке, что звучит.
 */
export const getPhrasePlaybackKey = (phraseId: number): string => String(phraseId);

/** Ключ звучания той же реплики с запасом по краям: вид остановки принимает нажатая кнопка */
export const getPaddedPhrasePlaybackKey = (phraseId: number): string => `${phraseId}:padded`;
